import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import {
  ANONYMOUS_RESEARCH_SESSION,
  fetchResearchSession,
  type ResearchSession,
} from "@/lib/research/access";

/**
 * Server-truth Research Operations session. The database decides whether the
 * signed-in person may enter the module; the UI only reflects that answer.
 */
export function useResearchSession(): { session: ResearchSession; isLoading: boolean } {
  const { user, loading } = useAuth();

  const query = useQuery({
    queryKey: ["research-session", user?.id ?? "anon"],
    queryFn: fetchResearchSession,
    enabled: !!user && !loading,
    staleTime: 60_000,
  });

  if (!user) {
    return { session: ANONYMOUS_RESEARCH_SESSION, isLoading: loading };
  }
  return {
    session: query.data ?? ANONYMOUS_RESEARCH_SESSION,
    isLoading: loading || query.isLoading,
  };
}
